import { loadView } from '@/helper/utils'
import { mainLayout } from '@/components/layouts/Main'

export default {
  path: '/support',
  component: mainLayout(loadView('support/Support')),
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      name: 'SupportBox',
      component: loadView('support/SupportBox'),
      meta: { requiresAuth: true }
    },
    {
      path: ':id',
      name: 'SupportBoxDetail',
      component: loadView('support/SupportBoxDetail'),
      meta: { requiresAuth: true }
    },
    {
      path: ':id/confirm',
      name: 'SupportMessageConfirm',
      component: loadView('support/SupportMessageConfirm'),
      meta: { requiresAuth: true, isConfirm: true }
    },
    {
      path: ':id/complete',
      name: 'SupportMessageComplete',
      component: loadView('support/SupportMessageComplete'),
      meta: { requiresAuth: true }
    }
  ]
}
